import { useSelector } from 'react-redux';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { routeTitles } from '../../../constants/routes';
import IconHelper from '../infoLabel/iconHelper';
import SidebarFooter from './sidebarFooter';
import SideBarSubMenu from './sidebarSubMenu';

const Sidebar = () => {
  const clasArDashboard = useSelector((state) => {
    return state.session?.clasArDashboard;
  });
  const navItems = useSelector((state) => {
    if (!clasArDashboard) {
      const navigationItems = state.support.navItems.filter(
        (item) => item.name !== routeTitles.DASHBOARD,
      );
      return navigationItems;
    }
    return state.support.navItems;
  });

  return (
    <div className="sidebar">
      <Nav vertical className="nav">
        {navItems.map(({ name, icon, link, nestedNavItems, namespacerAction }, index) => {
          return (
            <NavItem key={index.toString()}>
              {nestedNavItems?.length > 0 ? (
                <SideBarSubMenu
                  name={name}
                  icon={icon}
                  nestedNavItems={nestedNavItems}
                  namespacerAction={namespacerAction}
                />
              ) : (
                <NavLink activeClassName="nav-active" tag={RouterNavLink} to={`${link}`}>
                  {/* <i className={`fas ${icon}`} /> */}
                  {icon && <IconHelper iconType={icon} />}
                  {name}
                </NavLink>
              )}
            </NavItem>
          );
        })}
      </Nav>
      <SidebarFooter />
    </div>
  );
};

export default Sidebar;
